import { ImagesFormData, InstallationStatementType } from 'src/Libs/installation-statement/models/images'
import { getDefaultImageData } from 'src/Libs/installation-statement/utils/images'
import { GetFilesDto } from 'src/Libs/installation-statement/types'

export const transformGetFilesDtoToModel = (deviceLinkId: number, installationId: number, dto: GetFilesDto): ImagesFormData => {
  const imageData = getDefaultImageData(deviceLinkId, installationId)

  for (const type in imageData.images) {
    const index = dto.findIndex(n => n.tag === type)
    imageData.images[type as InstallationStatementType] = {
      ...imageData.images[type as InstallationStatementType],
      id: dto[index] ? dto[index].installationFilesId : undefined,
    }
  }

  return imageData
}
